// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_main_main_module_ts":"20b6bfa162dee368","src_app_map_map_module_ts":"74292890180811c0"}[chunkId] + ".js";
};